import { FolderKanban } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const projectenManifest: ModuleDefinition = {
  id: 'projecten',
  name: 'Projecten',
  icon: <FolderKanban size={20} />,
  color: '#7C6AA8',
  basePath: '/projecten',
  status: 'active',
  navItems: [
    { label: 'Projecten', path: '/projecten', icon: '' },
  ],
  component: () => import('./index.js'),
};

export default projectenManifest;
